module.exports = {"audiences":["newAndNeededConfirmationAndNoTeams"],"autoTrack":true,"experimentAllocation":0.1,"defaultWeight":1,"experimentVersion":"v3","defaults":{"enabled":false},"audienceSettings":{"startDate":"2018-09-12"},"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/confirmDuringSignup.json
// module id = BSp5
// module chunks = 1